/* eslint-disable max-len */
import { Box, Button, Skeleton, Typography } from "@mui/material";

import { AvatarCustom } from "../../../components";
import React from "react";
import SocAddIcon from "../../../components/Icons/SocAddIcon";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import useWellnessPurchaseData from "../../../hooks/redux-hooks/wellness-purchase-store/wellness-purchase-store";
import { PAGES_PATH } from "../../../navigation/params";

type IWellnessPlanPetPlanCardProps = {
  loading?: boolean;
  fromPaymentContainer?: boolean;
  disableChangePlan?: boolean;
};

const WellnessPlanPetPlanCard = (props: IWellnessPlanPetPlanCardProps) => {
  const navigate = useNavigate();
  const { loading = false, fromPaymentContainer, disableChangePlan = false } = props;
  const [searchParams] = useSearchParams();
  const { petList } = usePetStore();
  const { user } = useUserStore();
  const petId = searchParams.get("id");
  const { wellnessPurchaseData } = useWellnessPurchaseData();

  const currentPet = petList?.filter((pet) => pet.id == petId);

  const wrapperClass = fromPaymentContainer ?
    "bg-white px-4 pt-4 w-full" :
    "bg-white rounded-xl shadow-sm p-4 w-full";

  const avatarSize = fromPaymentContainer ? 72 : 80;
  const pawIconSize = fromPaymentContainer ? 24 : 25;

  return (
    <div className={wrapperClass}>
      <div className="flex justify-between">
        <div className="flex justify-between w-full items-center">
          <div className="flex gap-3 items-center">
            <div className="relative shrink-0">
              <AvatarCustom
                image={currentPet && currentPet[0]?.image}
                width={avatarSize}
                height={avatarSize}
                name={currentPet && currentPet[0]?.name}
              />
              <Box className="absolute bottom-1 right-0">
                <SocAddIcon height={pawIconSize} width={pawIconSize} />
              </Box>
            </div>

            <div className="flex flex-col">
              <Typography
                variant="h2"
                className="font-semibold"
                sx={{ fontSize: "20px", lineHeight: "24px" }}
              >
                {loading ? (
                  <Skeleton animation="wave" width={"9rem"} />
                ) : (
                  wellnessPurchaseData?.planName
                )}
              </Typography>
              <Typography
                sx={{ color: "black.main", fontSize: "14px", lineHeight: "20px" }}
              >
                {loading ? (
                  <Skeleton animation="wave" width={"5rem"} />
                ) : (
                  `${currentPet ? currentPet[0]?.name : ""} `
                )}
              </Typography>
            </div>
          </div>

          {(fromPaymentContainer || wellnessPurchaseData?.fromScratchPayRenewal) && (
            <Button
              variant="text"
              size="medium"
              disabled={disableChangePlan}
              sx={{
                "color": "violet.dark",
                "fontWeight": 600,
                "fontSize": "14px",
                "lineHeight": "20px",
                "textTransform": "none",
                "padding": 0,
                "minWidth": 0,
                "&:hover": {
                  background: "transparent",
                  color: "#7588DF",
                },
                "&.Mui-disabled": {
                  color: "neutral.dark",
                },
              }}
              onClick={() => {
                navigate(`${PAGES_PATH.WELLNESS_PLAN_DETAILS}?id=${petId}`);
              }}
            >
              Change Plan
            </Button>
          )}
        </div>
      </div>
      <div className="border-t border-taupe-50 mt-4 mb-1"></div>
      {fromPaymentContainer ? (
        <Typography className="!text-left !w-full !my-2 !text-sm !font-semibold">
          Home Hospital
        </Typography>
      ) : (
        <div className="flex justify-between">
          <Typography variant="subtitle2">
            {loading ? (
              <Skeleton animation="wave" width={"5rem"} />
            ) : (
              "GoodPet+"
            )}
          </Typography>
        </div>
      )}
      <div>
        {loading ? (
          <Skeleton animation="wave" width={"12rem"} />
        ) : (
          <Box className="text-sm flex gap-1 mt-1">
            {fromPaymentContainer ? (
              <img
                height={30}
                width={30}
                src="/assets/icons/location-paw-icon.svg"
                className="self-start"
              />
            ) : (
              <img
                height={18}
                width={18}
                src="/assets/icons/locationIcon.svg"
                className="self-center"
              />
            )}
            <div className="space-y-1 text-sm">
              {fromPaymentContainer ? (
                <>
                  <p className="font-semibold">
                    GoodVets {user?.location?.locationName}
                  </p>
                  <p className="text-xs">{user?.location?.address}</p>
                </>
              ) : (
                <p>GoodVets {user?.location?.locationName}</p>
              )}
            </div>
          </Box>
        )}
      </div>
      <div />
    </div>
  );
};

export default WellnessPlanPetPlanCard;
